import React, { useState } from 'react';

const Contact = () => {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <div className="bg-slate-950 text-slate-100 min-h-screen font-sans antialiased py-24 relative overflow-hidden">
      <div className="absolute top-0 left-1/3 w-96 h-96 bg-teal-500/5 rounded-full blur-3xl pointer-events-none" />

      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 relative z-10">
        
        {/* PAGE HEADER */}
        <div className="border-b border-slate-900 pb-10 mb-12 text-center sm:text-left">
          <span className="text-xs font-bold uppercase tracking-widest text-teal-400 bg-teal-950/40 px-3 py-1 rounded border border-teal-900/40">
            Communications Hub
          </span>
          <h1 className="text-4xl font-black text-white sm:text-5xl tracking-tight mt-4">
            Get in Touch
          </h1>
          <p className="mt-4 text-slate-400 text-lg font-medium leading-relaxed">
            Have a question, feedback, or a business proposition? Drop us a line below.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          
          {/* LEFT SIDE: DETAILS */}
          <div className="lg:col-span-5 space-y-6 font-medium">
            <div className="p-6 bg-slate-900/30 border border-slate-900 rounded-2xl">
              <h3 className="text-sm font-bold text-slate-400 uppercase tracking-wider">Inquiries & Partnerships</h3>
              <p className="text-white text-base mt-2 font-semibold">contact@moreview.in</p>
              <p className="text-xs text-slate-500 mt-1">We aim to respond to all professional proposals within 24–48 hours.</p>
            </div>
            
            <div className="p-6 bg-slate-900/30 border border-slate-900 rounded-2xl">
              <h3 className="text-sm font-bold text-slate-400 uppercase tracking-wider">Community Feedback</h3>
              <p className="text-slate-400 text-xs mt-2 leading-relaxed">
                Your opinions help shape our upcoming editions. Let us know what tech stacks, case studies, or optimization methods you want covered next.
              </p>
            </div>
          </div>

          {/* RIGHT SIDE: CONTACT FORM */}
          <div className="lg:col-span-7 bg-slate-900/50 border border-slate-900 p-6 sm:p-8 rounded-2xl shadow-xl">
            {submitted ? (
              <div className="text-center py-12">
                <span className="text-3xl">🎉</span>
                <h3 className="text-xl font-bold text-white mt-4">Transmission Successful</h3>
                <p className="text-sm text-slate-400 mt-2">Thank you for reaching out. Your message has been logged into our queue.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-5">
                <div>
                  <label className="block text-xs font-bold uppercase text-slate-400 tracking-wider mb-2">Your Name</label>
                  <input type="text" required className="w-full bg-slate-950 border border-slate-800 focus:border-indigo-500 rounded-xl px-4 py-3 text-sm text-white focus:outline-none transition-colors" placeholder="Sachin" />
                </div>
                
                <div>
                  <label className="block text-xs font-bold uppercase text-slate-400 tracking-wider mb-2">Email Address</label>
                  <input type="email" required className="w-full bg-slate-950 border border-slate-800 focus:border-indigo-500 rounded-xl px-4 py-3 text-sm text-white focus:outline-none transition-colors" placeholder="you@example.com" />
                </div>

                <div>
                  <label className="block text-xs font-bold uppercase text-slate-400 tracking-wider mb-2">Message</label>
                  <textarea required rows="4" className="w-full bg-slate-950 border border-slate-800 focus:border-indigo-500 rounded-xl px-4 py-3 text-sm text-white focus:outline-none transition-colors resize-none" placeholder="Write your message here..."></textarea>
                </div>

                <button type="submit" className="w-full bg-indigo-600 hover:bg-indigo-500 text-white text-sm font-bold py-3.5 rounded-xl shadow-lg shadow-indigo-600/10 transition-colors">
                  Send Message
                </button>
              </form>
            )}
          </div>

        </div>

      </div>
    </div>
  );
};

export default Contact;
